import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TopBannerComponent } from '../../shared/components/top-banner/top-banner.component';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  standalone: true,
  imports: [TopBannerComponent]
})
export class PrivacyComponent {

  constructor(private router: Router) { }

  public logoClick(): void {
    this.router.navigate(['account/login']);
  }
}
